module.exports = __webpack_public_path__ + "img/image.cfc0cbcd.gif";